"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformFeature = void 0;
var PlatformFeature;
(function (PlatformFeature) {
    PlatformFeature["CouponRedemption"] = "couponredemption";
    PlatformFeature["GiftRedemption"] = "giftredemption";
    PlatformFeature["GiftPurchase"] = "giftpurchase";
    PlatformFeature["ImpactShop"] = "isImpactShopEnabled";
    PlatformFeature["Maintenance"] = "downForMaintenance";
    PlatformFeature["CarbonRemovalPhaseOne"] = "carbonRemovalsPhaseOne";
    PlatformFeature["CaptchaScoreThreshold"] = "captchaScoreThreshold";
    PlatformFeature["HabitatRestorationPhaseOne"] = "habitatRestorationPhaseOne";
    PlatformFeature["FundReport"] = "fundReport";
})(PlatformFeature = exports.PlatformFeature || (exports.PlatformFeature = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHlwZXMvZmVhdHVyZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsSUFBWSxlQVVYO0FBVkQsV0FBWSxlQUFlO0lBQ3pCLHdEQUFxQyxDQUFBO0lBQ3JDLG9EQUFpQyxDQUFBO0lBQ2pDLGdEQUE2QixDQUFBO0lBQzdCLHFEQUFrQyxDQUFBO0lBQ2xDLHFEQUFrQyxDQUFBO0lBQ2xDLG1FQUFnRCxDQUFBO0lBQ2hELGtFQUErQyxDQUFBO0lBQy9DLDRFQUF5RCxDQUFBO0lBQ3pELDRDQUF5QixDQUFBO0FBQzNCLENBQUMsRUFWVyxlQUFlLEdBQWYsdUJBQWUsS0FBZix1QkFBZSxRQVUxQiJ9